import "../css/dash.css";
import {
  doc,
  deleteDoc,
  updateDoc,
  arrayRemove,
  collection,
  getDocs,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import {
  ref,
  listAll,
  deleteObject,
} from "firebase/storage";
import { db, storage, auth } from "../firebase";

export default function MenuComp({ menu, level }) {
  const nav = useNavigate();

  const handleEdit = () => {
    nav("/edit", { state: { menu: menu, level: level } });
  };

  const changeVis = async () => {
    let userConfirmed = window.confirm(
      `Are you sure you want change the visibility of "${menu.name}"?`
    );
    if (!userConfirmed) return;

    try {
      const menuDocRef = doc(db, "menus", menu.id);

      await updateDoc(menuDocRef, {
        public: !menu.public,
      });

      window.location.reload();
    } catch (e) {
      console.log(e);
      alert("Error changing visibility");
    }
  };

  // ----------------------------------------------------
  // 🔥 FULLY REWRITTEN DELETE FUNCTION (NO STYLE CHANGES)
  // ----------------------------------------------------

  const delMenu = async () => {
    const userConfirmed = window.confirm(
      `Are you sure you want to remove the menu "${menu.name}"? This action cannot be undone.`
    );
    if (!userConfirmed) return;

    try {
      const userDocRef = doc(db, "users", auth.currentUser.uid);
      const menuDocRef = doc(db, "menus", menu.id);

      // --- 1️⃣ DELETE ALL STORAGE FILES RECURSIVELY ---
      const deleteFolderRecursive = async (folderPath) => {
        const folderRef = ref(storage, folderPath);
        const list = await listAll(folderRef);

        // Delete all files
        if (list.items.length > 0) {
          await Promise.all(
            list.items.map((fileRef) => deleteObject(fileRef))
          );
        }

        // Delete all subfolders (recursive)
        if (list.prefixes.length > 0) {
          await Promise.all(
            list.prefixes.map((subfolder) =>
              deleteFolderRecursive(subfolder.fullPath)
            )
          );
        }
      };

      // Deletes everything under /menus/<menuId>/
      await deleteFolderRecursive(`menus/${menu.id}`);

      // --- 2️⃣ DELETE FIRESTORE SUBCOLLECTIONS ---

      const catRef = collection(db, "menus", menu.id, "categories");
      const catSnap = await getDocs(catRef);

      const deleteOps = [];

      for (const catDoc of catSnap.docs) {
        const itemsRef = collection(
          db,
          "menus",
          menu.id,
          "categories",
          catDoc.id,
          "items"
        );
        const itemsSnap = await getDocs(itemsRef);

        // Delete item docs
        itemsSnap.forEach((itemDoc) => {
          deleteOps.push(deleteDoc(itemDoc.ref));
        });

        // Delete category doc
        deleteOps.push(deleteDoc(catDoc.ref));
      }

      // Ensure all category + item deletes finish
      await Promise.all(deleteOps);

      // --- 3️⃣ DELETE MENU DOC + REMOVE MENU ID FROM USER ---
      await Promise.all([
        deleteDoc(menuDocRef),
        updateDoc(userDocRef, {
          menus: arrayRemove(menu.id),
        }),
      ]);

      // --- 4️⃣ REFRESH PAGE ---
      window.location.reload();
    } catch (error) {
      console.error("Error deleting menu:", error);
      alert("There was an issue removing your menu.");
    }
  };

  // ----------------------------------------------------

  return (
   <div className="menuCard" key={menu.id}>
  <div className="menuCard-header">
    <h4>{menu.name}</h4>
    <span
      className={`menu-status ${menu.public ? "active" : "private"}`}
      onClick={changeVis}
    >
      {menu.public ? "Active" : "Private"}
    </span>
  </div>

  <p className="menu-views">Views: {menu.views}</p>

  <div className="menuCard-actions">
    <button onClick={handleEdit} className="menu-btn edit">
      ✏️ Edit
    </button>

    <button onClick={delMenu} className="menu-btn delete">
      🗑 Delete
    </button>
  </div>
</div>
  );
}
